import React from 'react';
import { NavLink } from 'react-router-dom';

const links = [
  { to: '/', label: 'Experience', end: true },
  { to: '/projects', label: 'Software Projects' },
  { to: '/woodworking', label: 'Woodworking' },
];

function Nav() {
  return (
    <nav className="nav">
      {links.map(({ to, label, end }) => (
        <NavLink key={to} to={to} end={end} className="nav__link">
          {label}
        </NavLink>
      ))}
    </nav>
  );
}

export default Nav;
